"use client";

import { useEffect } from "react";
import { incrementNewsPostViewCount } from "@/app/actions/news";

export function NewsViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    incrementNewsPostViewCount(slug);
  }, [slug]);

  return null;
}
